import { render } from "./11FastScripture.vue?vue&type=template&id=60984340&scoped=true"
import script from "./11FastScripture.vue?vue&type=script&lang=js"
export * from "./11FastScripture.vue?vue&type=script&lang=js"

import "./11FastScripture.vue?vue&type=style&index=0&id=60984340&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60984340"]])

export default __exports__